
    import common from "@/util/common";
    import {useStore} from "@/store";
    import checkTitle from './checkTitle.vue';
    import checkDescrip from './checkDescrip.vue';
    import checkContent from './checkContent.vue';
    // import checkPosition from './checkPosition.vue';
    import {defineComponent, ComputedRef, computed, reactive, watch, toRefs} from 'vue';

    interface State {
        showDescrip: boolean;
        tocOnlyShowFlaw: boolean;
        contRenderData: object;
        isExpanded: boolean;
    }
    export default defineComponent({
        name: 'checkItem',
        props: {
            renderData: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            dataIndex: {
                type: Number,
                default: -1
            }
        },
        setup(props: any) {
            let state: State = reactive({
                showDescrip: false,
                tocOnlyShowFlaw: false,
                contRenderData: {},
                isExpanded: true
            }); 
            const {renderData} = toRefs(props);
            function getData(code, key='value', type='') {
                return common.getDataByCode(renderData.value.configItems, code, key, type)
            }
            // 判断是否有缺陷
            const hasDefect = computed(() => {
                const defectCount = getData('defectCount');
                return Number(defectCount) > 0;
            });
            let store = useStore();
            let reportData: ComputedRef<{}> = computed<{}>(() => store.state.reportData)
            watch(reportData, (data: any) => {
                const {checkModuleList} = JSON.parse(JSON.stringify(data));
                state.contRenderData = common.getDataByCode(checkModuleList, renderData.value.code, '', 1);
            }, {immediate: true, deep: true})
            
            let tocOnlyShowFlawS: ComputedRef<{}> = computed<{}>(() => store.state.tocOnlyShowFlaw)
            watch(tocOnlyShowFlawS, (data: any) => {
                state.tocOnlyShowFlaw = data;
            }, {immediate: true})

            const toggleExpand = () => {
                state.isExpanded = !state.isExpanded;
            }

            watch(hasDefect, (val) => {
                state.isExpanded = val;
            }, {immediate: true});

            return {
                state,
                getData,
                hasDefect,
                toggleExpand
            }
        },
        components: {
            checkTitle,
            checkDescrip,
            checkContent,
            // // checkPosition,
        }
    })
